export const ContainerStatuses = {
    NOT_CONTAINERIZED: 0,
    CONTAINERIZED: 1,
} as const;

export type ContainerStatus = typeof ContainerStatuses[keyof typeof ContainerStatuses];

export const ContainerStatusLabels: Record<ContainerStatus, string> = {
    [ContainerStatuses.NOT_CONTAINERIZED]: 'Unaccompanied',
    [ContainerStatuses.CONTAINERIZED]: 'Accompanied',
};

export const containerStatusOptions = (
    [
        [ContainerStatuses.CONTAINERIZED, 'Accompanied'],
        [ContainerStatuses.NOT_CONTAINERIZED, 'Unaccompanied'],
    ] as const
).map(([value, label]) => ({ value, label }));

export const getContainerStatusLabel = (v: number | string | null | undefined | boolean): string | undefined => {
    if (v == null) return undefined;
    const num = typeof v === 'string' ? Number(v) : v;
    return ContainerStatusLabels[num as ContainerStatus];
};
